import request from '../utils/request';

const BASE_URL = '/complaint-feedback';

const complaintFeedbackApi = {
  // 分页查询投诉反馈列表
  listComplaintFeedbacks(params = {}) {
    const {
      page = 1, 
      pageSize = 10, 
      sortField = 'create_time', 
      sortOrder = 'desc',
      ...queryParams
    } = params;

    return request.post(`${BASE_URL}/list`, {
        page,
        pageSize,
        sortField,
        sortOrder,
        ...queryParams
    });
  },

  // 获取投诉反馈详情
  getComplaintFeedbackDetail(id) {
    return request.get(`${BASE_URL}/detail/${id}`);
  },

  // 回复投诉反馈
  replyComplaintFeedback(replyData) {
    return request.post(`${BASE_URL}/reply`, replyData);
  },

  // 更新投诉反馈状态
  updateComplaintFeedbackStatus(id, status) {
    return request.put(`${BASE_URL}/status/${id}`, null, {
      params: { status }
    });
  }
};

export default complaintFeedbackApi;
